import React from 'react';

type Report = {
    class: number;
    description: string;
    count: number;
    unit: string;   // e.g. "100.00 €"
    total: string;  // e.g. "100.00 €"
};

type TableRow = {
    clubCountryNumber: number | string;
    title: string;
    bic: string;
    iban: string;
    reports: Report[];
    total: number | string;
};

type Props = {
    items: TableRow[];
};

const OldTable: React.FC<Props> = ({ items }) => {
    return (
        <table
            style={{ marginTop: 30 }}
            className="paymentlist-top content dtaus-col-hover w-full table-fixed text-[11px] border-collapse tracking-tight [&_td]:px-1 [&_td]:py-0.5 [&_td]:align-middle [&_td]:border [&_td]:border-gray-200 [&_td]:break-words [&_tr.center>td]:text-center [&_.money]:text-right [&_.money]:font-mono [&_tr.center>td]:w-8 [&_tbody>tr.center>td:nth-child(-n+20)]:bg-green-50"
        >
            <thead className="dtaus-head font-bold sticky top-16 z-20 shadow-sm">
                <tr className="table-header">
                    <td colSpan={1}>
                        Clubnr.
                    </td>
                    <td colSpan={4}>Clubname</td>
                    <td colSpan={4}>IBAN</td>
                </tr>
                <tr className="left">
                    <td colSpan={1}>Klasse</td>
                    <td colSpan={2}>Beschreibung</td>
                    <td colSpan={1} className="text-center">Anzahl</td>
                    <td colSpan={1}>Einzel</td>
                    <td colSpan={1}>Summe</td>
                    <td colSpan={4}>&nbsp;</td>
                </tr>
            </thead>
            <tbody>
                {items.map((item) => (
                    <>
                        <tr key={item.clubCountryNumber} className="bg-gray-100">
                            <td className="sticky left-0 top-28 z-10 bg-gray-100" colSpan={1}>
                                {item.clubCountryNumber}
                            </td>
                            <td colSpan={4} className="sticky top-28 z-10 bg-gray-100 font-medium text-xs">
                                <p className="p-2">{item.title}</p>
                            </td>
                            <td colSpan={4} className="sticky top-28 z-10 bg-gray-100">{item.iban}</td>
                        </tr>
                        {item.reports.map((report) => (
                            <tr className="left bg-white" key={report.class}>
                                <td colSpan={1}>Klasse {report.class}</td>
                                <td colSpan={2}>{report.description}</td>
                                <td colSpan={1} className="text-center">{report.count}</td>
                                <td colSpan={1}>{report.unit}</td>
                                <td colSpan={5}>{report.total}</td>
                            </tr>
                        ))}
                        {item.reports.length > 0 && (
                            <tr className="left bg-white font-bold">
                                <td colSpan={4}>&nbsp;</td>
                                <td colSpan={1}>Gesamtbetrag</td>
                                <td colSpan={4}>{item.total}</td>
                            </tr>
                        )}
                        {item.reports.length === 0 && (
                            <tr className="left bg-white">
                                <td colSpan={10}>
                                    <p className="p-2">Es wurde keine kostenpflichtige Meldung vom Club {item.title} abgegeben.</p>
                                </td>
                            </tr>
                        )}
                    </>

                ))}
            </tbody>
        </table>
    );
};

export default OldTable;


